import { Box, HStack, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { NAV_ITEMS } from "../../utils/etc";

export const DesktopNav = () => {
  return (
    <HStack gap={5}>
      {NAV_ITEMS.map((navItem, index) => (
        <Box key={index}>
          <Text
            to={navItem.href ?? "/"}
            as={Link}
            textStyle={"b-reg"}
            fontWeight={"medium"}
          >
            {navItem.label}
          </Text>
        </Box>
      ))}
    </HStack>
  );
};
